import { ImgHTMLAttributes } from 'react';

import logoFull from '../assets/brand/intellix-logo.png';
import logoMark from '../assets/brand/intellix-mark.png';

/** URL file biểu tượng. Marker bản đồ cần src ảnh thật — bọc thẻ img vào data URI SVG sẽ vỡ ảnh. */
export const logoMarkSrc: string = logoMark;

type LogoProps = ImgHTMLAttributes<HTMLImageElement>;

const baseStyle = { objectFit: 'contain' as const, display: 'block' };

/** Biểu tượng Intellix Pro (khối ribbon), dùng khi chỉ đủ chỗ cho icon. */
export function LogoImage({ alt = 'Intellix Pro', style, ...props }: LogoProps) {
  return <img src={logoMark} alt={alt} style={{ ...baseStyle, ...style }} {...props} />;
}

/** Logo đầy đủ: biểu tượng + Intellix Pro + TECH SOLUTIONS. */
export function LogoFull({ alt = 'Intellix Pro', style, ...props }: LogoProps) {
  return <img src={logoFull} alt={alt} style={{ ...baseStyle, ...style }} {...props} />;
}

export const HvsCircleLogo = LogoImage;
